var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagoListo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.75C1.5 3.57436 4.07436 1 7.25 1H17.25C20.4256 1 23 3.57436 23 6.75V16.75C23 19.9256 20.4256 22.5 17.25 22.5H7.25C4.07436 22.5 1.5 19.9256 1.5 16.75V6.75ZM7.25 2.5C4.90279 2.5 3 4.40279 3 6.75V16.75C3 19.0972 4.90279 21 7.25 21H17.25C19.5972 21 21.5 19.0972 21.5 16.75V6.75C21.5 4.40279 19.5972 2.5 17.25 2.5H7.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7803 15.2803C11.4874 15.5732 11.0126 15.5732 10.7197 15.2803L7.71967 12.2803C7.42678 11.9874 7.42678 11.5126 7.71967 11.2197C8.01256 10.9268 8.48744 10.9268 8.78033 11.2197L11.25 13.6893L16.7197 8.21967C17.0126 7.92678 17.4874 7.92678 17.7803 8.21967C18.0732 8.51256 18.0732 8.98744 17.7803 9.28033L11.7803 15.2803Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagoListo24X24);
export default __webpack_public_path__ + "static/media/PAGO_LISTO_24X24.d1efeed6737d4201d7e9d103c07acc61.svg";
export { ForwardRef as ReactComponent };